module.exports = __webpack_public_path__ + "static/media/vivo-banner-girl.bc69fd00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/vivo/vivo-banner-girl.png
// module id = 912
// module chunks = 7